export default "__VITE_ASSET__3a842cfc__"